import axios from 'axios'
import router from '@/router'

const baseURL = process.env.VUE_APP_API_BASE_URL
export default {
  namespaced: true,
  state: {
    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    userData: JSON.parse(localStorage.getItem('userData') || '{}'),
    userAbilities: JSON.parse(localStorage.getItem('userAbilities') || '{}'),
    isAuth: false,
  },
  getters: {
    userAuth: state => {
      if (state.userData.role === 'specialist') {
        return {
          authenticatedUser: state.userData.specialistId,
          first_name: state.userData.first_name,
          last_name: state.userData.last_name,
          name: state.userData.name,
          email: state.userData.email,
          role: state.userData.role,
          avatar: state.userData.avatar || null,
        }
      }
      if (state.userData.role === 'customer') {
        return {
          authenticatedUser: state.userData.customerId,
          first_name: state.userData.first_name,
          last_name: state.userData.last_name,
          name: state.userData.name,
          email: state.userData.email,
          role: state.userData.role,
          avatar: state.userData.avatar,
        }
      }
      if (state.userData.role === 'admin') {
        return {
          authenticatedUser: state.userData.id,
          first_name: state.userData.first_name,
          last_name: state.userData.last_name,
          name: state.userData.name,
          email: state.userData.email,
          role: state.userData.role,
          avatar: state.userData.avatar,
        }
      }
    },
  },
  mutations: {
    setToken(state, tokenValue) {
      localStorage.setItem('accessToken', tokenValue)
      state.accessToken = tokenValue
    },
    setRefreshTokenJwt(state, refreshTokenValue) {
      localStorage.setItem('refreshToken', refreshTokenValue)
      state.refreshToken = refreshTokenValue
    },
    setUser(state, userValue) {
      localStorage.setItem('userData', JSON.stringify(userValue))
      state.userData = userValue
    },
    setIsAuth(state, isAuthValue) {
      state.isAuth = isAuthValue
    },
    setAbilities(state, abilitiesValue) {
      localStorage.setItem('userAbilities', JSON.stringify(abilitiesValue))
      state.userAbilities = abilitiesValue
    },
    clearLogout(state) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userData')
      localStorage.removeItem('userAbilities')
      localStorage.removeItem('especialistaStatus')
      state.accessToken = ''
      state.refreshToken = ''
      state.userData = {}
      state.userAbilities = {}
      state.isAuth = false
    },
    updatePerfil(state, payload) {
      state.userData.avatar = payload.avatar
      const modifiedndstrigifiedForStorage = JSON.stringify(state.userData)
      localStorage.setItem('userData', modifiedndstrigifiedForStorage)
    },
  },
  actions: {
    async checkToken({ state }) {
      try {
        const tokenAuth = `Bearer ${state.accessToken}`

        const { data } = await axios.get(`${baseURL}authentication/authenticateToken`, {
          headers: { Authorization: tokenAuth },
        })

        return data
      } catch (error) {
        // Lidar com erros de atualização do token
        // console.log('error', error.response.data)
      }
    },
    async tokenRefreshJwt({ commit, state }) {
      try {
        const response = await axios.post(`${baseURL}authentication/refreshToken`, {
          refreshToken: state.refreshToken,
        })

        const { accessToken: newAccessToken, refreshToken: newRefreshToken } = response.data

        commit('setToken', newAccessToken)
        commit('setRefreshTokenJwt', newRefreshToken)

        return true
      } catch (error) {
        commit('clearLogout')
        router.push({ name: 'login' })
        // console.log('error', error.response.data)

        return false
      }
    },
  },
}
